import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BaseComment } from '../../../models/base/base-comment';

@Injectable({ providedIn: 'root' })
export class CommentsService {
  private _commentScrolledIntoView = new Subject<BaseComment>();
  public commentScrolledIntoView$ = this._commentScrolledIntoView as Observable<BaseComment>;
  public setCommentScrolledIntoView = (comment: BaseComment) => this._commentScrolledIntoView.next(comment);
}
